//浮点数精确计算
let $math = require('mathjs'); 
    /*
     * 判断obj是否为一个整数
     */
    function isInteger(obj) {
        return Math.floor(obj) === obj
    }

    /*
     * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
     * @param floatNum {number} 小数
     * @return {object}
     *   {times:100, num: 314}
     */
    export const  toInteger = (floatNum) => {
        var ret = {times: 1, num: 0};
        if (isInteger(floatNum)) {
            ret.num = floatNum;
            return ret
        }
        var strfi = floatNum + '';
        var dotPos = strfi.indexOf('.');
        var len = strfi.substr(dotPos + 1).length;
        var times = Math.pow(10, len);
        var intNum = parseInt(floatNum * times + 0.5, 10);
        ret.times = times;
        ret.num = intNum;
        return ret
    }

    /*
     * 核心方法，实现加减乘除运算，确保不丢失精度
     * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
     *
     * @param a {number} 运算数1
     * @param b {number} 运算数2
     * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
     *
     */
    function operation(a, b, op) {
        var o1 = toInteger(a);
        var o2 = toInteger(b);
        var n1 = o1.num;
        var n2 = o2.num;
        var t1 = o1.times;
        var t2 = o2.times;
        var max = t1 > t2 ? t1 : t2;
        var result = null;
        switch (op) {
            case 'add':
                if (t1 === t2) { // 两个小数位数相同
                    result = n1 + n2
                } else if (t1 > t2) { // o1 小数位 大于 o2
                    result = n1 + n2 * (t1 / t2)
                } else { // o1 小数位 小于 o2
                    result = n1 * (t2 / t1) + n2
                }
                return result / max;
            case 'subtract':
                if (t1 === t2) {
                    result = n1 - n2
                } else if (t1 > t2) {
                    result = n1 - n2 * (t1 / t2)
                } else {
                    result = n1 * (t2 / t1) - n2
                }
                return result / max;
            case 'multiply':
                result = (n1 * n2) / (t1 * t2);
                return result;
            case 'divide':
                result = (n1 / n2) * (t2 / t1);
                return result
        }
    }

    // 加减乘除的四个接口
    export const add = (a, b) => {
        return operation(a, b, 'add')
    }

    export const subtract = (a, b) => {
        return operation(a, b, 'subtract')
    }

    export const multiply = (a, b) => {
        return operation(a, b, 'multiply')
    }

    export const divide = (a, b) => {
        return operation(a, b, 'divide')
    }
    //保留index位小数
    export const toFixed = (index, num) => {
        return Math.round(num * 100 * index) / (100 * index)
    }
 //元转换成分
    export const accDiv = (arg1, arg2) =>{
              var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
              try { m += s1.split(".")[1].length } catch (e) { }
              try { m += s2.split(".")[1].length } catch (e) { }
              return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
        
    }
        
        //列表金额分转换成元
      export const  getAmount = (arg1, arg2) => {
          var t1 = 0, t2 = 0, r1, r2;
          try { t1 = arg1.toString().split(".")[1].length } catch (e) { }
          try { t2 = arg2.toString().split(".")[1].length } catch (e) { }
          r1 = Number(arg1.toString().replace(".", ""))
          r2 = Number(arg2.toString().replace(".", ""))
          return (r1 / r2) * Math.pow(10, t2 - t1);
        }

    //金额保留2位小数
export const setPrice = (price, max=1000000) => {
    if (!price) return "";
    let checkPlan = '' + price;
    checkPlan = checkPlan
        .replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
        .replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
        .replace(/^\./g, '') // 保证第一个为数字而不是.
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
    if (checkPlan.indexOf('.') < 0 && checkPlan !== '') {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        checkPlan = parseFloat(checkPlan) + ''
    } else if (checkPlan.indexOf('.') >= 0) {
        checkPlan = checkPlan
        .replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
    }
    if (checkPlan - max > 0) {
        var masStr = max.toString();
        checkPlan = checkPlan.substring(0, masStr.length - 1)
    }

    return checkPlan
}

    



// WEBPACK FOOTER //
// ./src/utils/digital.js